import { QuizTemplate } from "./types";
import { promptEnd, promptIntro } from "./utils";

export const beginnerCounting: QuizTemplate = {
  slug: "beginner-counting",
  titleHandle: "guide.beginnerCounting.title",
  shortTextHandle: "guide.beginnerCounting.shortText",
  longTextHandle: "guide.beginnerCounting.longText",
  level: "easy",
  questionPrompts: (userLanguageName: string, practiceLanguageName: string) => [
    {
      title: "Learn Basic Numbers",
      prompt:
        promptIntro(userLanguageName, practiceLanguageName) +
        `to learn basic numbers in ${practiceLanguageName}. 
          Start with numbers 1-10. The guide should explain how each number is said in ${practiceLanguageName}, including pronunciation and writing.` +
        promptEnd(userLanguageName, practiceLanguageName),
    },
    {
      title: "Counting Objects",
      prompt:
        promptIntro(userLanguageName, practiceLanguageName) +
        `to practice counting objects in ${practiceLanguageName}. 
          Include common objects like apples, books, and chairs. Demonstrate how to form sentences when counting, such as 'one apple', 'two books', etc.` +
        promptEnd(userLanguageName, practiceLanguageName),
    },
    {
      title: "Using Numbers in Everyday Context",
      prompt:
        promptIntro(userLanguageName, practiceLanguageName) +
        `to use numbers in everyday context in ${practiceLanguageName}.
          Explain situations like asking for quantities at a store, or telling time. Include relevant vocabulary and phrases.` +
        promptEnd(userLanguageName, practiceLanguageName),
    },
  ],
};
